export enum NotificationTypeEnum {
  Document = 1,
  Notification = 2,
}
